export default __webpack_public_path__ + "static/media/checked.7da2865a.svg";